import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="p-3 bg-transparent text-white text-center">
      <p>&copy; 2023 Seam Interns. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
